import template from './panel-container.html'
import css from './panel-container.css'
import { PanelContainerController } from './panel-container.controller.js'

export const PanelContainerComponent = {
  template: template,
  controller: PanelContainerController,
  controllerAs: 'PanelContainerController',
  transclude: true
}



// WEBPACK FOOTER //
// ./src/client/common/uiComponents/PanelContainer/panel-container.component.js